<script>
  /**
   * 横田工業の日報を月次で一覧表示する
   */
  import firebase from 'firebase/app'

  import MonthlyView from '../components/firestore/MonthlyView.svelte'
  import YokotaReportView from '../components/firestore/YokotaReportView.svelte'
</script>

<MonthlyView
  title={`横田工業 日報 一覧 <i class="fas fa-eye-slash" />`}
  getCollection={db => db.collection('yokota')}
  query={month => ref =>
    ref
      .where(firebase.firestore.FieldPath.documentId(), '>=', `${month}`)
      .where(firebase.firestore.FieldPath.documentId(), '<=', `${month}\uf8ff`)
      .orderBy(firebase.firestore.FieldPath.documentId(), 'desc')}
  key="date"
  let:id
  let:index
  let:filtered
>
  <!-- 編集するためのリンク -->
  <a
    href="/yokota-report-form?date={id}"
    target="_blank"
    style="color: inherit; text-decoration: inherit;"
  >
    <!-- 対象日の日報を縦に並べて表示 -->
    {#each filtered as data}
      <span>保存日時: {data.createAt.toDate().toLocaleString()}</span>
      <YokotaReportView {data} isEditable={false} />
    {/each}
  </a>
</MonthlyView>
